export const PAYMENT_METHOD = "v1/payment-method";
